import { useDocumentTitle } from "usehooks-ts";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { TabbedNav } from "../TabbedNav";
import { EditSearchTagsPage } from "./EditSearchTags";
import { GlobalAssociations } from "./GlobalAssociations";
import { DEFAULT_SEARCH_PAGE, SEARCH_TAG_CHOICES } from "./constants";

export const SearchTags: React.FC<{ isEditor: boolean }> = ({ isEditor }) => {
  useDocumentTitle("Search Tags");
  const { tagType } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!tagType) {
      navigate(`./${DEFAULT_SEARCH_PAGE}`);
    }
  }, [navigate, tagType]);

  if (!tagType) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <header className="flex items-center gap-8">
        <h1 className="text-2xl font-bold">Search Tags</h1>
        <TabbedNav choices={SEARCH_TAG_CHOICES} />
      </header>
      {tagType === "tags" && <EditSearchTagsPage isEditor={isEditor} />}
      {tagType === "global" && <GlobalAssociations />}
    </div>
  );
};
